export default "__VITE_ASSET__w5iR_sSY__"